import { useContext } from "react";

import { FeatureFlagsContext, type FeatureFlagsContextProps } from "../providers/feature-flags.context";

export const useFeatureFlags = (): FeatureFlagsContextProps => {
	return useContext(FeatureFlagsContext);
};
